import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";
import Media from "../views/Media.vue";
import MediaArticle from "../views/MediaArticle.vue";
import MedgateApp from "../views/MedgateApp.vue";
import Jobs from "../views/Jobs.vue";
import Callback from "../views/Callback.vue";
import Video from "../views/Video.vue";
import Register from "../views/Register.vue";
import Privacy from "../views/Privacy.vue";
import Business from "../views/Business.vue";
import About from "../views/About.vue";
import Shop from "../views/Shop.vue";
import ShopAssignment from "../views/ShopAssignment.vue";
import ShopPromo from "../views/ShopPromo.vue";
import ShopPromoCheckout from "../views/ShopPromoCheckout.vue";
import ShopCheckout from "../views/ShopCheckout.vue";
import ShopMerchant from "../views/ShopMerchant.vue";
// import ShopMerchantCode from "../views/ShopMerchantCode.vue";
import ShopMerchantCheckout from "../views/ShopMerchantCheckout.vue";
import Reseller from "../views/reseller/Home.vue";
import ResellerLayout from "../views/reseller/ResellerLayout.vue";
import ResellerKeyAssignment from "../views/reseller/KeyAssignment.vue";
import ResellerCheckout from "../views/reseller/Checkout.vue";
import CallbackSpeed from "../views/CallbackSpeed.vue";
import AlarmCenterReferral from "../views/AlarmCenterReferral.vue";
import CustomerServiceSteerage from "../views/CustomerServiceSteerage.vue";
import TermsAndConditions from "../views/TermsAndConditions.vue";
import NotFound from "../views/NotFound.vue";
import ShopAssignmentSingle from "../views/ShopAssignmentSingle.vue";
import ShopAssignmentFamily from "../views/ShopAssignmentFamily.vue";
import ShopAssignmentFamilyPlus from "../views/ShopAssignmentFamilyPlus.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // component: Home
    // redirect: '/shop'
    component: Shop
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    path: "/media",
    name: "Media",
    component: Media
  },
  {
    path: '/media/article/:id/:title',
    name: "MediaArticle",
    component: MediaArticle
  },
  {
    path: "/medgate-app",
    name: "MedgateApp",
    component: MedgateApp
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: Jobs
  },
  {
    path: "/callback",
    name: "Callback",
    component: Callback
  },
  {
    path: "/video",
    name: "Video",
    component: Video
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy
  },
  {
    path: "/business",
    name: "Business",
    component: Business
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/shop",
    name: "Shop",
    component: Shop
  },
  {
    path: "/shop/assignment",
    name: "ShopAssignment",
    component: ShopAssignment
  },
  {
    path: "/shop/checkout",
    name: "ShopCheckout",
    component: ShopCheckout
  },
  {
    path: "/shop/promo/:slug",
    name: "ShopMerchant",
    component: ShopMerchant
  },
  {
    path: "/shop/promocode/:slug",
    name: "ShopPromo",
    component: ShopPromo
  },
  // {
  //   path: "/shop/promo-code",
  //   name: "ShopMerchantCode",
  //   component: ShopMerchantCode
  // },
  {
    path: "/shop/promocode/checkout/:slug",
    name: "ShopPromoCheckout",
    component: ShopPromoCheckout
  },
  {
    path: "/shop/promo/checkout/:slug",
    name: "ShopMerchantCheckout",
    component: ShopMerchantCheckout
  },

  /**
   * Shop Key Assignment for Family Plans
   *   Single - 3 members
   *   Family - 7 + 2 members
   *   Family Plus - unlimited memberes
   */
  {
    path: "/shop/keyassignmentsingle",
    name: "ShopAssignmentSingle",
    component: ShopAssignmentSingle
  },
  {
    path: "/shop/keyassignmentfamily",
    name: "ShopAssignmentFamily",
    component: ShopAssignmentFamily
  },
  {
    path: "/shop/keyassignmentfamilyplus",
    name: "ShopAssignmentFamilyPlus",
    component: ShopAssignmentFamilyPlus
  },


  /**
   * Reseller
   */
  // {
  //   path: "/shop/reseller/:slug",
  //   name: "ResellerHome",
  //   component: Reseller
  // },
  // {
  //   path: "/shop/reseller/assignment/:slug",
  //   name: "ResellerKeyAssignment",
  //   component: ResellerKeyAssignment
  // },
  // {
  //   path: "/shop/reseller/checkout/:slug",
  //   name: "ResellerCheckout",
  //   component: ResellerCheckout
  // },

  {
    path: "/shop/reseller/:slug",
    name: "ResellerLayout",
    redirect: `/shop/reseller/:slug/`,
    component: ResellerLayout,
    children: [
      {
        path: `/shop/reseller/:slug/`,
        name: "ResellerHome",
        component: Reseller
      },
      {
        path: "/shop/reseller/assignment/:slug",
        name: "ResellerKeyAssignment",
        component: ResellerKeyAssignment
      },
      {
        path: "/shop/reseller/checkout/:slug",
        name: "ResellerCheckout",
        component: ResellerCheckout
      }
    ]
  },


  {
    path: "/callback/speed",
    name: "CallbackSpeed",
    component: CallbackSpeed
  },
  {
    path: "/program/generali/alarm-center-referral",
    name: "AlarmCenterReferral",
    component: AlarmCenterReferral
  },
  {
    path: "/program/intellicare/customer-service-steerage",
    name: "CustomerServiceSteerage",
    component: CustomerServiceSteerage
  },
  {
    path: "/terms-and-conditions/:slug",
    name: "TermsAndConditions",
    component: TermsAndConditions
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:catchAll(.*)',
    redirect:'404'
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
});

// router.beforeEach((to, from, next) => {
//   console.log({ to, from, next });
//   console.log({ test: new Vue})
// });

export default router;
